function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { InteractionManager } from "./Utils/InteractionManager";
import { Particle } from "./Particle";
import { Point } from "./Utils/Point";
import { QuadTree } from "./Utils/QuadTree";
import { Rectangle } from "./Utils/Rectangle";
import { calcPositionFromSize } from "../Utils/NumberUtils";
import { errorPrefix } from "./Utils/Constants";
var qTreeCapacity = 4;
var qTreeRectangle = function qTreeRectangle(canvasSize) {
  return new Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2);
};
export var Particles = /*#__PURE__*/function () {
  function Particles(engine, container) {
    var _this = this;
    _classCallCheck(this, Particles);
    this._applyDensity = function (options, manualCount, group) {
      var _options$number$densi;
      if (!((_options$number$densi = options.number.density) !== null && _options$number$densi !== void 0 && _options$number$densi.enable)) {
        return;
      }
      var numberOptions = options.number,
        densityFactor = _this._initDensityFactor(numberOptions.density),
        optParticlesNumber = numberOptions.value,
        optParticlesLimit = numberOptions.limit > 0 ? numberOptions.limit : optParticlesNumber,
        particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount,
        particlesCount = Math.min(_this.count, _this._array.filter(function (t) {
          return t.group === group;
        }).length);
      _this.limit = numberOptions.limit * densityFactor;
      if (particlesCount < particlesNumber) {
        _this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
      } else if (particlesCount > particlesNumber) {
        _this.removeQuantity(particlesCount - particlesNumber, group);
      }
    };
    this._initDensityFactor = function (densityOptions) {
      var container = _this._container;
      if (!container.canvas.element || !densityOptions.enable) {
        return 1;
      }
      var canvas = container.canvas.element,
        pxRatio = container.retina.pixelRatio;
      return canvas.width * canvas.height / (densityOptions.factor * Math.pow(pxRatio, 2) * densityOptions.area);
    };
    this._pushParticle = function (position, overrideOptions, group, initializer) {
      try {
        var particle = _this.pool.pop();
        if (particle) {
          particle.init(_this._nextId, position, overrideOptions, group);
        } else {
          particle = new Particle(_this._engine, _this._nextId, _this._container, position, overrideOptions, group);
        }
        var canAdd = true;
        if (initializer) {
          canAdd = initializer(particle);
        }
        if (!canAdd) {
          return;
        }
        _this._array.push(particle);
        _this._zArray.push(particle);
        _this._nextId++;
        _this._engine.dispatchEvent("particleAdded", {
          container: _this._container,
          data: {
            particle: particle
          }
        });
        return particle;
      } catch (e) {
        console.warn("".concat(errorPrefix, " adding particle: ").concat(e));
        return;
      }
    };
    this._engine = engine;
    this._container = container;
    this._nextId = 0;
    this._array = [];
    this._zArray = [];
    this.pool = [];
    this.limit = 0;
    this.needsSort = false;
    this.lastZIndex = 0;
    this._interactionManager = new InteractionManager(this._engine, this._container);
    var canvasSize = this._container.canvas.size;
    this.quadTree = new QuadTree(qTreeRectangle(canvasSize), qTreeCapacity);
    this.movers = this._engine.plugins.getMovers(this._container, true);
    this.updaters = this._engine.plugins.getUpdaters(this._container, true);
  }
  _createClass(Particles, [{
    key: "count",
    get: function get() {
      return this._array.length;
    }
  }, {
    key: "addManualParticles",
    value: function addManualParticles() {
      var container = this._container,
        options = container.actualOptions;
      var _iterator = _createForOfIteratorHelper(options.manualParticles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;
          this.addParticle(particle.position ? particle.position.mode === "precise" ? particle.position : calcPositionFromSize({
            size: container.canvas.size,
            position: particle.position
          }) : undefined, particle.options);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "addParticle",
    value: function addParticle(position, overrideOptions, group, initializer) {
      var container = this._container,
        options = container.actualOptions,
        limit = options.particles.number.limit;
      if (limit > 0) {
        var countToRemove = this.count + 1 - limit;
        if (countToRemove > 0) {
          this.removeQuantity(countToRemove);
        }
      }
      return this._pushParticle(position, overrideOptions, group, initializer);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._array = [];
      this._zArray = [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._array = [];
      this._zArray = [];
      this.movers = [];
      this.updaters = [];
    }
  }, {
    key: "draw",
    value: function () {
      var _draw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(delta) {
        var container, canvasSize, _iterator2, _step2, _ref3, _ref2, plugin, _iterator3, _step3, p;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this._container, canvasSize = this._container.canvas.size;
                this.quadTree = new QuadTree(qTreeRectangle(canvasSize), qTreeCapacity);
                container.canvas.clear();
                _context.next = 5;
                return this.update(delta);
              case 5:
                if (this.needsSort) {
                  this._zArray.sort(function (a, b) {
                    return b.position.z - a.position.z || a.id - b.id;
                  });
                  this.lastZIndex = this._zArray[this._zArray.length - 1].position.z;
                  this.needsSort = false;
                }
                _iterator2 = _createForOfIteratorHelper(container.plugins);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _ref3 = _step2.value;
                    _ref2 = _slicedToArray(_ref3, 2);
                    plugin = _ref2[1];
                    container.canvas.drawPlugin(plugin, delta);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                _iterator3 = _createForOfIteratorHelper(this._zArray);
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    p = _step3.value;
                    p.draw(delta);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function draw(_x) {
        return _draw.apply(this, arguments);
      }
      return draw;
    }()
  }, {
    key: "filter",
    value: function filter(condition) {
      return this._array.filter(condition);
    }
  }, {
    key: "find",
    value: function find(condition) {
      return this._array.find(condition);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this._interactionManager.handleClickMode(mode);
    }
  }, {
    key: "init",
    value: function init() {
      var container = this._container,
        options = container.actualOptions;
      this.lastZIndex = 0;
      this.needsSort = false;
      var handled = false;
      this.updaters = this._engine.plugins.getUpdaters(container, true);
      this._interactionManager.init();
      var _iterator4 = _createForOfIteratorHelper(container.plugins),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref8 = _step4.value;
          var _ref5 = _slicedToArray(_ref8, 2);
          var plugin = _ref5[1];
          if (plugin.particlesInitialization !== undefined) {
            handled = plugin.particlesInitialization();
          }
          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this._interactionManager.init();
      var _iterator5 = _createForOfIteratorHelper(container.pathGenerators),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref9 = _step5.value;
          var _ref7 = _slicedToArray(_ref9, 2);
          var pathGenerator = _ref7[1];
          pathGenerator.init(container);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.addManualParticles();
      if (!handled) {
        for (var group in options.particles.groups) {
          var groupOptions = options.particles.groups[group];
          for (var i = this.count, j = 0; j < ((_groupOptions$number = groupOptions.number) === null || _groupOptions$number === void 0 ? void 0 : _groupOptions$number.value) && i < options.particles.number.value; i++, j++) {
            var _groupOptions$number;
            this.addParticle(undefined, groupOptions, group);
          }
        }
        for (var _i2 = this.count; _i2 < options.particles.number.value; _i2++) {
          this.addParticle();
        }
      }
    }
  }, {
    key: "push",
    value: function push(nb, mouse, overrideOptions, group) {
      this.pushing = true;
      for (var i = 0; i < nb; i++) {
        this.addParticle(mouse === null || mouse === void 0 ? void 0 : mouse.position, overrideOptions, group);
      }
      this.pushing = false;
    }
  }, {
    key: "redraw",
    value: function () {
      var _redraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.clear();
                this.init();
                _context2.next = 4;
                return this.draw({
                  value: 0,
                  factor: 0
                });
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function redraw() {
        return _redraw.apply(this, arguments);
      }
      return redraw;
    }()
  }, {
    key: "remove",
    value: function remove(particle, group, override) {
      this.removeAt(this._array.indexOf(particle), undefined, group, override);
    }
  }, {
    key: "removeAt",
    value: function removeAt(index) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var group = arguments.length > 2 ? arguments[2] : undefined;
      var override = arguments.length > 3 ? arguments[3] : undefined;
      if (index < 0 || index > this.count) {
        return;
      }
      var deleted = 0;
      for (var i = index; deleted < quantity && i < this.count; i++) {
        var particle = this._array[i];
        if (!particle || particle.group !== group) {
          continue;
        }
        particle.destroy(override);
        this._array.splice(i--, 1);
        var zIdx = this._zArray.indexOf(particle);
        this._zArray.splice(zIdx, 1);
        this.pool.push(particle);
        deleted++;
        this._engine.dispatchEvent("particleRemoved", {
          container: this._container,
          data: {
            particle: particle
          }
        });
      }
    }
  }, {
    key: "removeQuantity",
    value: function removeQuantity(quantity, group) {
      this.removeAt(0, quantity, group);
    }
  }, {
    key: "setDensity",
    value: function setDensity() {
      var options = this._container.actualOptions,
        groups = options.particles.groups;
      for (var group in groups) {
        this._applyDensity(groups[group], 0, group);
      }
      this._applyDensity(options.particles, options.manualParticles.length);
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(delta) {
        var container, particlesToDelete, _iterator6, _step6, _ref14, _ref11, pathGenerator, _iterator7, _step7, _ref15, _ref13, plugin, _iterator8, _step8, particle, resizeFactor, _iterator10, _step10, _ref18, _ref17, _plugin, _iterator11, _step11, mover, _iterator9, _step9, _particle, _iterator12, _step12, updater;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                container = this._container, particlesToDelete = new Set();
                _iterator6 = _createForOfIteratorHelper(container.pathGenerators);
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _ref14 = _step6.value;
                    _ref11 = _slicedToArray(_ref14, 2);
                    pathGenerator = _ref11[1];
                    pathGenerator.update();
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                _iterator7 = _createForOfIteratorHelper(container.plugins);
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _ref15 = _step7.value;
                    _ref13 = _slicedToArray(_ref15, 2);
                    plugin = _ref13[1];
                    plugin.update && plugin.update(delta);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
                _iterator8 = _createForOfIteratorHelper(this._array);
                _context3.prev = 6;
                _iterator8.s();
              case 8:
                if ((_step8 = _iterator8.n()).done) {
                  _context3.next = 43;
                  break;
                }
                particle = _step8.value;
                resizeFactor = container.canvas.resizeFactor;
                if (resizeFactor && !particle.ignoresResizeRatio) {
                  particle.position.x *= resizeFactor.width;
                  particle.position.y *= resizeFactor.height;
                  particle.initialPosition.x *= resizeFactor.width;
                  particle.initialPosition.y *= resizeFactor.height;
                }
                particle.ignoresResizeRatio = false;
                _context3.next = 15;
                return this._interactionManager.reset(particle);
              case 15:
                _iterator10 = _createForOfIteratorHelper(this._container.plugins);
                _context3.prev = 16;
                _iterator10.s();
              case 18:
                if ((_step10 = _iterator10.n()).done) {
                  _context3.next = 27;
                  break;
                }
                _ref18 = _step10.value;
                _ref17 = _slicedToArray(_ref18, 2);
                _plugin = _ref17[1];
                if (!particle.destroyed) {
                  _context3.next = 24;
                  break;
                }
                return _context3.abrupt("break", 27);
              case 24:
                if (_plugin.particleUpdate) {
                  _plugin.particleUpdate(particle, delta);
                }
              case 25:
                _context3.next = 18;
                break;
              case 27:
                _context3.next = 32;
                break;
              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3["catch"](16);
                _iterator10.e(_context3.t0);
              case 32:
                _context3.prev = 32;
                _iterator10.f();
                return _context3.finish(32);
              case 35:
                _iterator11 = _createForOfIteratorHelper(this.movers);
                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    mover = _step11.value;
                    if (mover.isEnabled(particle)) {
                      mover.move(particle, delta);
                    }
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }
                if (!particle.destroyed) {
                  _context3.next = 40;
                  break;
                }
                particlesToDelete.add(particle);
                return _context3.abrupt("continue", 41);
              case 40:
                this.quadTree.insert(new Point(particle.getPosition(), particle));
              case 41:
                _context3.next = 8;
                break;
              case 43:
                _context3.next = 48;
                break;
              case 45:
                _context3.prev = 45;
                _context3.t1 = _context3["catch"](6);
                _iterator8.e(_context3.t1);
              case 48:
                _context3.prev = 48;
                _iterator8.f();
                return _context3.finish(48);
              case 51:
                this._array = this._array.filter(function (t) {
                  return !particlesToDelete.has(t);
                });
                _context3.next = 54;
                return this._interactionManager.externalInteract(delta);
              case 54:
                _iterator9 = _createForOfIteratorHelper(this._array);
                _context3.prev = 55;
                _iterator9.s();
              case 57:
                if ((_step9 = _iterator9.n()).done) {
                  _context3.next = 66;
                  break;
                }
                _particle = _step9.value;
                _iterator12 = _createForOfIteratorHelper(this.updaters);
                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    updater = _step12.value;
                    updater.update(_particle, delta);
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }
                if (!(!_particle.destroyed && !_particle.spawning)) {
                  _context3.next = 64;
                  break;
                }
                _context3.next = 64;
                return this._interactionManager.particlesInteract(_particle, delta);
              case 64:
                _context3.next = 57;
                break;
              case 66:
                _context3.next = 71;
                break;
              case 68:
                _context3.prev = 68;
                _context3.t2 = _context3["catch"](55);
                _iterator9.e(_context3.t2);
              case 71:
                _context3.prev = 71;
                _iterator9.f();
                return _context3.finish(71);
              case 74:
                delete container.canvas.resizeFactor;
              case 75:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 45, 48, 51], [16, 29, 32, 35], [55, 68, 71, 74]]);
      }));
      function update(_x2) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }]);
  return Particles;
}();